module.exports = __webpack_public_path__ + "901de8a417306b83d2522cbfc0822f2e.svg";